import type { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'

const StyledDiv = styled.div`
  display: flex;
  box-sizing: border-box;
  flex: 1 1 auto;
  min-width: 12.5rem;
  @media only screen and (min-width: 768px) {
    max-width: calc(33.33% - 1rem);
  }
  @media only screen and (min-width: 75rem) {
    max-width: 12%;
  }
`

const Column: FunctionComponent<{
  children?: ReactNode
}> = ({ children, ...otherProps }) => <StyledDiv {...otherProps}>{children}</StyledDiv>

export default Column
